export class IepFormsWithinDocuments {
  // Version
  IsOptional: boolean;
  IsAllowMultiple: boolean;
  TemplateVersionId: number;
  TemplateName: string;
  TemplateNameHTML: string;
  DoumentName: string;
  Sequence: number;
  TemplateCollectionId: number;
  StudentCollectionTemplateVersionId: number;
  StudnetXMLId: number;
  LastModifiedBy: string;
  LastModifiedDate: Date;
  TemplateId: number;
  IsLocked: boolean;
  NewVersion: boolean;
  ToolTip: string;
  CreatorId: number;
  HTMLDATAStream: string;
  UserName: string;
  IsEdit: boolean;
  IsCreator: boolean;
  Version: number;
  CheckedOutByUserId: number;
  CheckedOutByuserName: string;
  ModifiedByUserName: string;
  IsMarkedComplete: boolean;
  TeamMemberPermissionId: number;
  // non Dto
  StatusChecked = false;
}

export class ImportedDocuments {
  SpedDocumentId: number;
  Description: string;
  DocumentName: string;
  CreatedDate: Date;
  UserName: string;
  SpEdDocumentToStudentInstanceId: number;
  FileBase64: string;
  // non dto Fields
  MyFileBase64String: string;
  FileType: string;
  FileName: string;
  StudentId: number;
  spedCollectionToStudentId: number;
  FileExtension: string;
}

export class GoalData {
  GoalDescription = '';
  ObjectiveDescription = '';
  FieldName = '';
  ObjFieldName = '';
  FirstName = '';
  LastName = '';
  StudentCollectionId: number;
  StudentId: number;
  StudentCollectionTemplateVersionId: number;
  MasterTypeId: number;
  TemplateVersionId: number;
  TemplateName = '';
}

export class OptionalForms {
  CollectionId: number;
  Version: number;
  IsOptional: boolean;
  IsAllowMultiple: boolean;
  TemplateVersionId: number;
  TemplateName: string;
  Sequence: number;
  TemplateCollectionId: number;

  // Non Dto
  StatusChecked = false;
}

export class TeamMemberPermission {
  SpedTemplateVersionId: number;
  SpedCollectionId: number;
  IsEdit: boolean;
}

export class SpedTeamMemberUpdate {
  CollectionToStudentId: number;
  TeacherUserId: number;
  Template: string;
}
export class PickIdentification {
  StudentCollectionId: number;
  StudentCollectionTemplateVersionId: number;
  StudentId: number;
  IdentificationDesc: string;
  IdentificationCode: string;
  DualIdentificationDesc: string;
  DualIdentificationCode: string;
  TertiaryIdentificationDesc: string;
  TertiaryIdentificationCode: string;
  QuaternaryIdentificationDesc: string;
  QuaternaryIdentificationCode: string;
  FifthIdentificationDesc: string;
  FifthIdentificationCode: string;
  TemplateName: string;
  TemplateVersionId: number;
  IdentificationId: number;
  DualIdentificationId: number;
  TertiaryIdentificationId: number;
  QuaternaryIdentificationId: number;
  FifthIdentificationId: number;
}

export class IdentificationSubCodes {
  Code: string;
  Description: string;
  LongDescription: string;
  Sequence: number;
  Active: boolean;
  DataId: number;
}
export class PlaMaintenance {
  StudentCollectionId: number;
  StudentCollectionTemplateVersionId: number;
  StudentId: number;
  CategoryName: string;
  RowIndex: number;
  CategoryDescription: string;
  CategoryNote: string;
  UserName: string;
  TemplateName: string;
  TemplateVersionId: string;
}
export class PickCourseOfStudy {
  StudentCollectionId: number;
  StudentCollectionTemplateVersionId: number;
  CategoryDescription: string;
  StudentId: number;
  TemplateName: string;
  TemplateVersionId: string;
}

export class FormListSequence {
  StudentCollectionId: number;
  TemplateVersionId: number;
  StudentCollectionTemplateVersionId: number;
  Sequence: number;
}

export class StudentCollectionTemplate {
  CheckOutByUserId: number;
  UserName: string;
  CheckedOutByUserName: string;
}